import { combineReducers } from "redux";
import Assignment from "routes/Home/Attendance/Salary/Assignment/Module";
import RulePack from "routes/Home/Attendance/Salary/RulePack/Module";
import Report from "routes/Home/Attendance/Salary/Report/Module";
import AdditionsAndSubtractions from "routes/Home/Attendance/Salary/Post/Module";
import SalaryFish from "routes/Home/Attendance/Salary/SalaryFish/Module";
import Modifier from "routes/Home/Attendance/Salary/Modifier/Module";

const reducers = combineReducers({
  Assignment,
  RulePack,
  Report,
  AdditionsAndSubtractions,
  SalaryFish,
  Modifier,
});

export default reducers;
